import { render, staticRenderFns } from "./TipoNivelAcademicoPage.vue?vue&type=template&id=113863be&"
import script from "./TipoNivelAcademicoPage.js?vue&type=script&lang=js&"
export * from "./TipoNivelAcademicoPage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports